import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import LoadingButton from '@mui/lab/LoadingButton';
import Tooltip from '@mui/material/Tooltip';
import { clearValues } from '../FormBuilderLibrary/slice';

import { exportFormToPDF } from '../../utils/utilFunctions';
import { useIndividualApplicationData } from '../../pages/IndividualApplication/utils';

const SimulateSaveButton = ({
	marginBottom,
	setOuterLoadingCancel,
	readOnlyTest,
	setReadOnlyTest,
	readOnlyReset,
	setReadOnlyReset,
	setReadOnly,
	setAlertBalloon,
	formMetaInfo,
	applicationId,
	applicationTitle
}) => {
	const dispatch = useDispatch();
	const formSchema = useSelector((state) => state.form.formSchema?.[0]) ?? [];
	const formAnswers = useSelector((state) => state.form.form);
	const { data: application } = useIndividualApplicationData();
	const [loadingCancel, setLoadingCancel] = useState(false);
	const pathSegments = window.location.pathname.split('/');
	const applicationUniqueID =
		pathSegments.find((s) => s.includes('api-')) || formMetaInfo?.form_id || '';

	return (
		<div
			style={{
				width: '100%',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'flex-end',
				gap: '15px',
				marginBottom: marginBottom
			}}
		>
			<p
				style={{
					color: '#ED6C02',
					marginRight: 'auto',
					marginBottom: '0px',
					fontSize: '14px'
				}}
			>
				You can test your form, fill it with content, see if business logic works, etc. Anything you
				input will be not saved in reality, this is only for the master form testing.
			</p>
			<>
				<LoadingButton
					variant="contained"
					onClick={() =>
						exportFormToPDF(
							{
								...formMetaInfo,
								form_schema: formSchema,
								field_values: formAnswers?.[1] ?? [],
								applicationTitle: applicationTitle || application?.project_title || '',
								applicationUniqueID
							},
							null,
							applicationId,
							true
						)
					}
				>
					Print Form PDF
				</LoadingButton>
				<LoadingButton
					disabled={readOnlyTest}
					data-testid={'formBuilder-saveForm'}
					variant="contained"
					onClick={() => {
						const element = document.getElementById('testing-form-saveButton');
						element.click();
						setReadOnlyReset(false);
					}}
				>
					TEST FORM
				</LoadingButton>
				<Tooltip title={readOnlyReset ? `Nothing to reset` : ``} placement="top" arrow>
					<span>
						<LoadingButton
							disabled={readOnlyReset}
							variant="outlined"
							loading={loadingCancel}
							onClick={() => {
								setAlertBalloon({ isOpen: false });
								setReadOnly(false);
								setReadOnlyTest(false);
								setLoadingCancel(true);
								setOuterLoadingCancel && setOuterLoadingCancel(true);
								dispatch(clearValues());
								setTimeout(function () {
									setReadOnlyReset(true);
									setLoadingCancel(false);
									setOuterLoadingCancel && setOuterLoadingCancel(false);
								}, 1000);
							}}
						>
							RESET
						</LoadingButton>
					</span>
				</Tooltip>
			</>
		</div>
	);
};

export default SimulateSaveButton;
